import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import whatsappImg from '@mssgme/app/img/iconWhatsapp.svg';
import instagramImg from '@mssgme/app/img/insta.svg';
import { Spinner } from '@mssgme/ui';
import { useActions } from '@mssgme/hooks';

import styles from './styles.scss';

export default function IntegrationList({ className, integrations }) {
    const { api } = useActions();
    const { t } = useTranslation();
    const [isFetching, setIsFetching] = useState(false); // todo: use 'useFetching'

    const handleRemove = async (id, type) => {
        setIsFetching(type);

        try {
            await api.integrations.delete({ integrationId: id });
        } catch (e) {
            alert(e);
        }

        setIsFetching(false);
    };

    return (
        <div className={classNames(styles.root, className)}>
            {integrations.map((integration) => (
                <div className={styles.integration} key={integration.type}>
                    <img className={styles.logo} src={integration.logo} alt={integration.label} />
                    <div className={styles.labelsContainer}>
                        <span className={styles.label}>{integration.label}</span>
                        {integration.integrated && (
                            <span className={styles.status}>{t('IntegrationList.connected')}</span>
                        )}
                    </div>
                    {integration.integrated ? (
                        <span
                            className={classNames(styles.button, styles.red, { [styles.isFetching]: isFetching })}
                            onClick={() => handleRemove(integration.id, integration.type)}
                        >
                            {isFetching && isFetching === integration.type ? (
                                <Spinner size="14" color="white" className={styles.spinner} />
                            ) : (
                                t('IntegrationList.remove')
                            )}
                        </span>
                    ) : (
                        <NavLink exact to={integration.path} className={styles.button}>
                            {t('IntegrationList.add')}
                        </NavLink>
                    )}
                </div>
            ))}
            <div className={styles.integration} key="whatsapp">
                <img className={styles.logo} src={whatsappImg} alt="whatsapp" />
                <span className={styles.label}>WhatsApp</span>
                <span className={classNames(styles.button, styles.soonLabel)}>{t('IntegrationList.soon')}</span>
            </div>
            {/* <div className={styles.integration} key="instagram">
                <img className={styles.logo} src={instagramImg} alt="instagram" />
                <span className={styles.label}>Instagram</span>
                <span className={classNames(styles.button, styles.soonLabel)}>{t('IntegrationList.soon')}</span>
            </div> */}
        </div>
    );
}

IntegrationList.propTypes = {
    className: PropTypes.string,
    integrations: PropTypes.array.isRequired,
};

IntegrationList.defaultProp = {
    integrations: [],
};
